<bento-alert [items]="alerts">
</bento-alert>

<ng-template #applicationColumnCell let-item>
	<span *ngIf="migrationSource === TAX_COMPETITOR_MIGRATION_SOURCE; else applicationLink">
				{{item.metadata.competitorDescription}}
	</span>
	<ng-template #applicationLink>
		<button class="btn btn-link btn-lg goto-product"
				data-qe-id="migration-dashboard-inprogress-application-link"
				type="button" (click)="gotoProduct.emit(item)">
					<span *ngIf="item.migrationSource !== TAX_COMPETITOR_MIGRATION_SOURCE; else thirdPartyName">
						{{item.migrationSource | applicationName }}
					</span>
			<ng-template #thirdPartyName>
						<span>
						{{item.metadata.competitorDescription}}
						</span>
			</ng-template>
		</button>
	</ng-template>
</ng-template>
<ng-template #startedOnColumnCell let-item>
	{{item.migrationStartDate | formatDateTime}}
</ng-template>
<ng-template #statusColumnCell let-item>
	<ng-container *ngIf="item.migrationStatus === MigrationStatus.PENDING_CONFLICTS">
		{{'onvio.setup.migrations.status.inprogress.pending.conflicts' | translate}} - {{item.progress}}%
	</ng-container>
	<ng-container *ngIf="item.migrationStatus === MigrationStatus.IN_PROGRESS">
		{{'onvio.setup.migrations.status.inprogress' | translate}} - {{item.progress}}%
	</ng-container>
	<ng-container *ngIf="item.migrationStatus === MigrationStatus.INQUEUE">
		{{'onvio.setup.migrations.status.inprogress.inqueue' | translate}} - {{item.progress}}%
	</ng-container>
</ng-template>
<ng-template #progressColumnCell let-item>
	<ngb-progressbar type="info" [value]="item.progress"></ngb-progressbar>
</ng-template>

<ng-template #onlyInprogressTable>
	<app-table [tableModel]="tableModel"></app-table>
</ng-template>

<ng-template #tableHeader>
	<h2>
		{{'onvio.setup.migrations.status.inprogress' | translate }}
		<span class="badge badge-info inprogress-badge-count" *ngIf="migrationResults">{{migrationResults.length}}</span>
	</h2>
	<span class="timestamp" data-testid="lastUpdatedTimestamp" *ngIf="migrationResults?.length && lastUpdatedTimestamp">
			{{'onvio.setup.migrations.status.inprogress.last_updated' | translate}} {{lastUpdatedTimestamp}}
	</span>
</ng-template>

<div class="grid grid-cols-2" [bentoBusyLoader]="showBusyloader">
	<ng-container *ngIf="migrationResults?.length && !showOnlyTable">
		<ng-container *ngTemplateOutlet="tableHeader"></ng-container>
	</ng-container>
	<div class="col-span-2">
		<ng-container *ngIf="migrationResults?.length">
			<ng-container *ngTemplateOutlet="onlyInprogressTable"></ng-container>
		</ng-container>
		<ng-container *ngIf="!migrationResults?.length">
			<ng-container *ngTemplateOutlet="customTemplate ? customTemplate : defaultTemplate"></ng-container>
		</ng-container>
	</div>
</div>

<app-migration-conflicts *ngIf="conflictMigration"
						 [migrationId]="conflictMigration?.migrationId"
						 [productName]="productName"
						 (allConflictsResolved)="handleAllConflictsResolved($event)"
						 [migrationSource]="migrationSource"
						 data-testid="conflictResolutionUI">
</app-migration-conflicts>

<ng-template #defaultTemplate>
  <p>
    <strong>{{'onvio.setup.migrations.nothing.completed' | translate}}</strong>
  </p>
</ng-template>
